import { useState } from 'react';
import PhotoPlaceholder from '../components/photo-placeholder';
import Lightbox from '../components/lightbox';
import { TRABAJOS, TRABAJOS_FILTROS } from '../data/content';
import { eyebrow, h1, bodyText, pageWrap } from '../lib/styles';

const Work = () => {
  const [filtro, setFiltro] = useState('Todo');
  const [light, setLight] = useState(null);
  const filtered = filtro === 'Todo' ? TRABAJOS : TRABAJOS.filter((t) => t.cat === filtro);

  return (
    <div style={pageWrap}>
      <span style={eyebrow}>Nuestros trabajos</span>
      <h1 style={h1}>Galería</h1>
      <p style={{ ...bodyText, maxWidth: '52ch', margin: '0 0 3vw' }}>
        Trabajo hecho en el salón. Toca cualquier imagen para verla en grande.
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 9, marginBottom: '3vw' }}>
        {TRABAJOS_FILTROS.map((f) => {
          const active = filtro === f;
          return (
            <button
              key={f}
              onClick={() => setFiltro(f)}
              style={{
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontSize: 12.5,
                letterSpacing: '.08em',
                textTransform: 'uppercase',
                padding: '9px 18px',
                borderRadius: 'var(--radius-pill)',
                border: `1px solid ${active ? 'var(--rose-700)' : 'var(--ink-200)'}`,
                background: active ? 'var(--rose-700)' : '#FFF',
                color: active ? '#FFF' : 'var(--ink-600)',
              }}
            >
              {f}
            </button>
          );
        })}
      </div>
      <div style={{ columnCount: 2, columnGap: 14 }} className="z-gallery">
        {filtered.map((t) => (
          <PhotoPlaceholder
            key={t.label}
            label={t.label}
            nota={t.cat}
            ratio={t.ratio}
            onClick={() => setLight(t.label)}
            style={{ width: '100%', breakInside: 'avoid', marginBottom: 14 }}
          />
        ))}
      </div>
      <Lightbox label={light} onClose={() => setLight(null)} />
    </div>
  );
};

export default Work;
